import { styled, useTheme } from "@mui/material/styles";
import { FoodsIcon, FoodsIllustrations, IconMapping, IllustrationMapping, WhiteBox } from "@foodpilot/foods";
import { Stack, Typography } from "@mui/material";
import { Button } from "@foodpilot/foods";
import { ReactNode } from "react";

export const Wrapper = styled(WhiteBox)<{ direction: "row" | "column" }>(({ theme, direction = "column" }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(4),
    flexDirection: direction,
    padding: theme.spacing(4),
    textAlign: direction === "row" ? "left" : "center",
}));

type EmptyStateCardProps = {
    direction?: "row" | "column";
    title: string;
    description: string;
    action?: {
        label: string | ReactNode;
        onClick: () => void;
        icon?: keyof IconMapping;
    };
    illustration?: keyof IllustrationMapping;
};

export const EmptyStateCard = (props: EmptyStateCardProps) => {
    const { direction = "column", title, description, action, illustration = "notEnoughData" } = props;

    const theme = useTheme();
    return (
        <Wrapper direction={direction}>
            <FoodsIllustrations illustration={illustration} />
            <Stack gap={1}>
                <Typography variant="h3">{title}</Typography>
                <Typography variant="h4" fontWeight={theme.typography.fontWeightMedium}>
                    {description}
                </Typography>
            </Stack>
            {action && (
                <Button variant="primary" onClick={action.onClick}>
                    <Stack direction="row" alignItems="center" gap={theme.spacing(1)}>
                        {action.icon && <FoodsIcon icon={action.icon} size={1} />}
                        {action.label}
                    </Stack>
                </Button>
            )}
        </Wrapper>
    );
};

export default EmptyStateCard;
